/**
 * 手机号码脱敏工具函数
 * @param phone 手机号码
 * @returns 脱敏后的手机号码（前3位 + ******* + 后4位）
 */
export function maskPhoneNumber(phone: string | undefined | null): string {
    if (!phone || typeof phone !== 'string') {
        return '';
    }

    // 移除所有非数字字符
    const cleanPhone = phone.replace(/\D/g, '');

    // 如果不是11位手机号，直接返回原字符串
    if (cleanPhone.length !== 11) {
        return phone;
    }

    // 前3位 + ******* + 后4位
    return cleanPhone.slice(0, 3) + '*'.repeat(4) + cleanPhone.slice(-4);
}
